import select2 from "select2";
import $ from "jquery";
import { isEmpty, filter, isArray, includes, get, has, toString } from "lodash";

select2($);

const globalConfig = {
    theme: 'tailwindcss-3',
    placeholder: "Choose from below.",
    width: '100%',
}

// Handle the select2 will go out of bound in small screen size
const makeSelect2Responsive = (selectElement) => {
    const $select = $(selectElement);
    const $container = $select.next('.select2-container');

    if ($container.length > 0) {
        $container.css({
            'width': '100%',
            'max-width': '100%',
            'min-width': '0'
        });

        // Make placeholder overflow hidden else will go second row
        const $placeholder = $container.find('.select2-selection__placeholder');
        if ($placeholder.length > 0) {
            $placeholder.css({
                'overflow': 'hidden'
            });
        }

        const $selection = $container.find('.select2-selection__rendered');
        $selection.find('.select2-selection__placeholder').css({
            'overflow': 'hidden'
        });
    }
}

const initSelect2 = () => {
    const selectEl = $('[data-toggle="select2"]');
    const select2ElWithBorderDanger = selectEl.filter('.border-danger');
    const select2ElWithInline = selectEl.filter('.in-line');
    const select2ElWithoutBorderDanger = selectEl.not('.border-danger, .in-line');

    if (select2ElWithoutBorderDanger.length > 0) {
        select2ElWithoutBorderDanger.each(function() {
            $(this).select2(globalConfig);
            makeSelect2Responsive(this);
        });
    }
    if (select2ElWithBorderDanger.length > 0) {
        select2ElWithBorderDanger.each(function() {
            $(this).select2({
                ...globalConfig,
                selectionCssClass: '!border-danger'
            });
            makeSelect2Responsive(this);
        });
    }
    if (select2ElWithInline.length > 0) {
        select2ElWithInline.each(function() {
            $(this).select2({
                ...globalConfig,
                selectionCssClass: 'in-line'
            });
            makeSelect2Responsive(this);
        });
    }

    const select2MultipleEl = $('[data-toggle="select2-multiple"]');
    if (select2MultipleEl.length > 0) {
        select2MultipleEl.attr('multiple', 'multiple');
        select2MultipleEl.each(function () {
            $(this).find("option").filter(function () {
                return !this.value.trim();
            }).remove();
        });
        select2MultipleEl.each(function() {
            $(this).select2({
                ...globalConfig,
                multiple: true,
                allowClear: true,
            });
            makeSelect2Responsive(this);
        });
    }
}

const handleSelect2Filter = (fieldId, options, key, value) => {
    let result;
    let defaultValue;

    if (isEmpty(fieldId) || isEmpty(options) || isEmpty(key)) {
        return;
    }

    fieldId = $.escapeSelector(fieldId);
    const field = $(`#${fieldId}`);
    if (isEmpty(field) || field.length === 0) {
        return;
    }

    options = filter(options, (option) => {
        return (get(option, 'value') !== null) && (get(option, 'name') !== null);
    });

    if (isEmpty(value)) {
        result = options.map(option => ({
            id: get(option, 'value'),
            text: get(option, 'name'),
            [key]: get(option, key),
        }));
        field.empty();
        field.select2({
            ...globalConfig,
            data: result,
        });
        makeSelect2Responsive(field[0]);
        return;
    }

    result = filter(options, (option) => {
        if (has(option, key)) {
            let currentValue = toString(get(option, key));
            return isArray(value) ? includes(value, currentValue) : (currentValue === value);
        }
        return true;
    });

    if (!isEmpty(result)) {
        defaultValue = field.val();

        result = result.map(option => {
            return {
                id: get(option, 'value'),
                text: get(option, 'name'),
                [key]: get(option, key),
                selected: isArray(defaultValue) ? includes(defaultValue, toString(get(option, 'value'))) : (defaultValue === toString(get(option, 'value'))),
            };
        });
    }

    field.empty();
    field.select2({
        ...globalConfig,
        data: result ?? [],
    });
    makeSelect2Responsive(field[0]);
}

export {
    handleSelect2Filter,
    initSelect2
};
